// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HistoryTrend_wrapper__3qCD2"};